<template>
  <div class="text-capitalize">
    <download-invoices-modal :is-active.sync="isDowloading" @downloaded="invoicesDownloaded" />
    <data-table
      :headers="headers"
      :url="url"
      title="Transfers"
      searchable
      ref="table"
      :fields="fields"
      :csv="true"
      csvFileName="transfers.csv"
      :csvFields="csvFields"
      :archive="true"
      :dateSort="true"
      :csvParams="csvParams"
      @date-range-updated="(url) => (this.url = url)"
      @update-archived="(status) => (this.showArchived = status)"
      @click:row="showTransferDetails"
    >
      <template slot="action.icons">
        <v-btn color="primary" class="mr-2" @click="isDowloading = true">
          <v-icon color="light-blue lighten-4 mr-2">
            mdi-email-send
          </v-icon>
          Process Invoices
        </v-btn>
        <v-btn
          color="primary"
          fab
          small
          :loading="downloadingInvoices"
          :disabled="downloadingInvoices"
          @click="downloadInvoices"
          title="Download Invoices"
        >
          <v-icon>mdi-folder-download-outline</v-icon>
        </v-btn>
      </template>
      <template slot="item.type" slot-scope="{ item }">{{ item.type | title }}</template>
      <template slot="item.provider" slot-scope="{ item }">{{ item.provider | title }}</template>
      <template slot="item.payment_delivery" slot-scope="{ item }">{{
        item.payment_delivery ? "Yes" : "No"
      }}</template>
    </data-table>
  </div>
</template>

<script>
import { downloadFile } from "@/components/tables/utils";
import DownloadInvoicesModal from "./downloadInvoicesForm";

export default {
  components: { DownloadInvoicesModal },
  data() {
    return {
      isDowloading: false,
      showArchived: false,
      downloadingInvoices: false,
      url: "/api/v1/payments",
      headers: {
        created_at: "Date (created at)",
        "initiator.full_name": "Sender full name",
        "initiator.country": "Sender country",
        "data.recipient_name": "Récipient full name",
        "data.country": "Récipient Country",
        amount: " Amount (Euro)",
        type: "Payment Type",
        status: "Payment Status",
        "transfer.status": "Transfer Status",
        "transfer.cashout_status": "Cashout Status",
        payment_delivery: "To Deliver",
      },
      /*  Days before transfer */
      fields: {
        status: { type: "title" },
        "transfer.status": { type: "title" },
      },
      csvParams: { transferStatus: "completed", per_page: 10 },
      csvFields: [
        {
          label: "Type",
          value: "data.type",
          default: "Facture",
        },
        {
          label: "Référence du client",
          value: "initiator.id",
          default: "",
        },
        {
          label: "Date",
          value: "transfer.done_at",
          default: "",
        },
        {
          label: "Nom du client",
          value: "initiator.full_name",
          default: "",
        },
        {
          label: "Référence",
          value: "transfer.id",
          default: "",
        },
        {
          label: "Compte du grand livre",
          value: "data.ledger",
          default: "",
        },
        {
          label: "Détails",
          value: "data.details",
          default: "Achat de cryptomonnaies",
        },
        {
          label: "Net",
          value: "transfer.amount_in_euros",
          default: "",
        },
        {
          label: "Taux TVA",
          value: "data.tax",
          default: "0%",
        },
        {
          label: "TVA",
          value: "data.vat",
          default: "0",
        },
        {
          label: "Total",
          value: "transfer.amount_in_euros",
          default: "",
        },
        {
          label: "Type d'analyse 1",
          value: "data.analysis_1",
          default: "",
        },
        {
          label: "Type d'analyse 2",
          value: "data.analysis_2",
          default: "",
        },
        {
          label: "Type d'analyse 3",
          value: "data.analysis_3",
          default: "",
        },
      ],
    };
  },
  methods: {
    showTransferDetails({ id }) {
      return this.$router.push({ name: "transfers.show", params: { id } });
    },
    invoicesDownloaded({ message }) {
      this.isDowloading = false;
      Notify.success(message);
    },
    downloadInvoices() {
      this.downloadingInvoices = true;
      this.$http({
        url: "api/v1/downloadCompletePaymentsInvoices",
        method: "GET",
        responseType: "blob",
      })
        .then((response) => downloadFile(response, "invoices.zip", "application/zip"))
        .catch((error) => {
          if (error.response.status === 400) {
            Notify.error("Invoices have not yet been processed.");
            return;
          }
          Notify.errorFromResponse(error);
        })
        .finally(() => (this.downloadingInvoices = false));
    },
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
    showArchived: function (val) {
      const params = this.$refs.table.addParams(this.url, []);
      // const params = "";
      if (val) {
        this.url = `/api/v1/payments/all?${params}`;
      } else {
        this.url = `/api/v1/payments?${params}`;
      }
    },
  },
};
</script>
